import { Button } from "@client/components/button/Button";
import { useAuth, useWaitlistManagement } from "@client/hooks";

export function WaitlistButton() {
	const { isAuthenticated } = useAuth();
	const {
		status: waitlistStatus,
		loading,
		joining,
		leaving,
		join,
		leave,
		error,
	} = useWaitlistManagement();

	if (!isAuthenticated) {
		return null;
	}

	const isLoading = loading || joining || leaving;

	return (
		<div className="flex items-center gap-2">
			{waitlistStatus ? (
				<div className="flex flex-col items-center gap-0">
					<span className="text-sm text-green-600 dark:text-green-400 font-medium">
						✓ In waitlist
					</span>
					<Button
						onClick={leave}
						disabled={isLoading}
						variant="ghost"
						size="sm"
						className="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 h-6 px-2"
					>
						{leaving ? "Removing..." : "Remove from list"}
					</Button>
				</div>
			) : (
				<Button
					onClick={join}
					disabled={isLoading}
					variant="primary"
					size="lg"
					className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold px-8 py-3 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
				>
					{joining ? "Joining..." : "Join waitlist"}
				</Button>
			)}
			{error && (
				<div className="text-sm text-red-600 dark:text-red-400">
					Error: {error.message || error.error}
				</div>
			)}
		</div>
	);
}
